"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("./objectAssign");

// Derived straight from the source:
// github.com/facebook/react/blob/master/src/classic/types/ReactPropTypes.js
function makeChainable(validate) {
  function checkType(isRequired, props, propName, componentName, location) {
    componentName = componentName || 'ANONYMOUS';

    if (props[propName] == null) {
      if (isRequired) {
        return new Error("Required prop `" + propName + "` was not specified in " + ("`" + componentName + "`."));
      }

      return null;
    }

    return validate(props, propName, componentName, location);
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}
/**
 * React PropTypes helper that allows you to register your own validations,
 * which support `.isRequired` chaining. Takes an optional set of
 * existing PropTypes to start with.
 */


var PropTypes =
/*#__PURE__*/
function () {
  function PropTypes() {
    var existingPropTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, PropTypes);
    // shallow clone original object
    Object.assign(this, existingPropTypes);
  }

  (0, _createClass2.default)(PropTypes, [{
    key: "register",
    value: function register(key, validator) {
      if (this[key] != null) {
        throw new Error("Prop Validator with name `" + key + "` already exists.");
      }

      this[key] = validator.dontWrap ? validator : makeChainable(validator);
      return this;
    }
  }, {
    key: "registerAll",
    value: function registerAll(obj) {
      var _this = this;

      Object.keys(obj).forEach(function (key) {
        if (key !== '__esModule') {
          _this.register(key, obj[key]);
        }
      });
      return this;
    }
  }]);
  return PropTypes;
}();

exports.default = PropTypes;
module.exports = exports.default;